
import * as Header from "./headerStyles";
import { useWindowWidth } from "@react-hook/window-size";
import NormalMenu from "./NormalMenu";
import BurgerMenu from "./BurgerMenu";
import { useEffect, useState } from "react";
import { SidebarContext } from "../../context/sidebarContext";

export default function HeaderContainer(){
    
    const windowWidth = useWindowWidth();
    
    const [show,setShow] = useState(true)
    const [scrollPos,setScrollPos] = useState(0)
    const [onTop,setOnTop] = useState(window.scrollY===0)

    const handleScroll = () => {
        setScrollPos(document.body.getBoundingClientRect().top)
        
        if(sidebar){
            setShow(true)
        }else if(!show && (document.body.getBoundingClientRect().top > scrollPos)) {
            setShow(true)
        }else if (show && !(document.body.getBoundingClientRect().top > scrollPos)){
            setShow(false)
        }

        setOnTop(window.scrollY===0)
      };

    window.addEventListener("scroll", handleScroll);


    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setTimeout(() => {
          setIsMounted(true);
        }, 1000);
        
    }, []);

    
    const [sidebar,setSidebar] = useState(false)
    const showSidebar = () => setSidebar(!sidebar)

    return (
        <SidebarContext.Provider value={{ sidebar, showSidebar }}>
        <Header.Container active={show} top={onTop}>
            <Header.Group>
                {!isMounted?
                    <Header.Item href="">
                        <Header.Logo src="/logo.png"/>
                    </Header.Item> 
                    :
                    <Header.ItemMounted href="">
                        <Header.Logo src="/logo.png"/>
                    </Header.ItemMounted> 
                }

            </Header.Group>
            
            {windowWidth >= 800 ? <NormalMenu mounted={isMounted}/> : <BurgerMenu mounted={isMounted}/>}

        </Header.Container>
      </SidebarContext.Provider>
    )
}
